import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;
  information: string;
  duration: string;
  warning?: string;

  handleClose(): void;
}

const SearchDurationInfoDialog: React.FC<Props> = ({ open, information, duration, warning, handleClose }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('linkedinSearchDurationInfoTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{information}</Typography>
          <Typography className={classes.text}>{duration}</Typography>
          {!_.isNil(warning) ? <Typography className={cx(classes.text, 'highlight')}>{warning}</Typography> : null}
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default SearchDurationInfoDialog;
